// Portable contract, independent of Firestore. No operational fields are allowed.
export const FORMAT = 'valenpos.product-transfer';
export const SCHEMA_VERSION = 1;
export const MAX_PRODUCTS = 3000;
export const normalizeText = (value) => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
export const normalizeUnit = (value) => {
  const unit = String(value || '').trim().toLowerCase();
  if (['gramo', 'gramos', 'gr'].includes(unit)) return 'g';
  if (['mililitro', 'mililitros'].includes(unit)) return 'ml';
  return unit || 'unidad';
};
const optional = (rule) => ({ ...rule, optional: true });
const string = { kind: 'string' };
const text = { kind: 'string', nonempty: true };
const number = { kind: 'number', min: 0 };
const positive = { kind: 'number', min: 0, exclusive: true };
const integer = { ...number, integer: true };
const boolean = { kind: 'boolean' };
const enumeration = (...values) => ({ kind: 'enum', values });
const array = (item) => ({ kind: 'array', item });
const object = (fields, nullable = false) => ({ kind: 'object', fields, nullable });
const unit = enumeration('g', 'ml', 'unidad');
const item = object({ productRef: text, name: string, qty: positive, unit });
const group = object({ id: text, label: text, min: integer, max: { ...integer, min: 1 }, perPickQty: positive, unit, selectorRef: text, defaultProductRef: optional(text) });
const recipe = object({ baseItems: array(item), choiceGroups: array(group) });
const promotion = object({ enabled: boolean, sourceProductRef: text, sourceProductName: string, quantity: { ...integer, min: 2 }, weekdays: array({ ...integer, max: 6 }) });
const config = object({
  recipe: optional(recipe), promotion: optional(promotion), isIceCream: optional(boolean),
  base: optional(enumeration('cono', 'vaso')), baseInsumoRef: optional(text), baseInsumoName: optional(string),
  extraItems: optional(array(item)), sabores: optional({ ...integer, min: 1 }), gramosPorSabor: optional(positive),
  servilletas: optional(integer), cucharas: optional(integer),
}, true);
export const productSchema = object({
  ref: text, sourceProductId: text,
  data: object({
    name: text, barcode: string, code: optional(string), sku: optional(string), price: number, costPrice: number, category: string,
    type: enumeration('final', 'insumo', 'receta'), unit: enumeration('', 'g', 'ml', 'unidad'),
    config, excludeFromEntries: boolean,
    yieldConfig: optional(object({ enabled: boolean, expectedYieldPercent: { ...number, max: 100 } }, true)),
    trackStock: optional(boolean), recipeMode: optional(enumeration('backflush')),
  }),
  warnings: array(object({ code: text, message: text })),
});
export const transferSchema = object({
  format: enumeration(FORMAT), schemaVersion: enumeration(SCHEMA_VERSION), exportId: text, exportedAt: text,
  source: object({ name: text }), products: array(productSchema),
  dependencies: object({ products: array(productSchema), selectors: array(object({
    ref: text, kind: enumeration('category'), sourceCategory: text, unit, memberRefs: array(text),
  })) }),
});

export function checkSchema(value, rule = transferSchema, path = 'archivo', errors = []) {
  if (value === undefined && rule.optional) return errors;
  if (value === null && rule.nullable) return errors;
  const fail = (message) => errors.push(`${path}: ${message}`);
  if (rule.kind === 'object') {
    if (!value || typeof value !== 'object' || Array.isArray(value)) { fail('debe ser un objeto'); return errors; }
    Object.keys(value).forEach((key) => { if (!Object.prototype.hasOwnProperty.call(rule.fields, key)) fail(`campo no permitido: ${key}`); });
    Object.entries(rule.fields).forEach(([key, child]) => checkSchema(value[key], child, `${path}.${key}`, errors));
  } else if (rule.kind === 'array') {
    if (!Array.isArray(value)) fail('debe ser una lista');
    else value.forEach((entry, index) => checkSchema(entry, rule.item, `${path}[${index}]`, errors));
  } else if (rule.kind === 'enum') {
    if (!rule.values.includes(value)) fail('valor no soportado');
  } else if (typeof value !== rule.kind) fail(`tipo inválido (${rule.kind})`);
  else if (rule.kind === 'string' && rule.nonempty && !value.trim()) fail('no puede estar vacío');
  else if (rule.kind === 'number' && (!Number.isFinite(value) || value < rule.min || (rule.exclusive && value === rule.min) || (rule.max !== undefined && value > rule.max) || (rule.integer && !Number.isInteger(value)))) fail('número fuera de rango');
  return errors;
}
